// @flow

import AssemblyItemQuantityCellRenderer from './components/table/AssemblyItemQuantityCellRenderer';

export const components = {
    'tableCellRenderer:assemblyItemQuantity': AssemblyItemQuantityCellRenderer,
}
